import React from 'react';
import { LucideProps } from 'lucide-react';
import { cn } from '../../lib/utils';

export const SarasIQ = React.forwardRef<SVGSVGElement, LucideProps>(
  ({ color = 'currentColor', size = 24, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 35 36"
        fill={color}
        className={cn('lucide lucide-saras-iq', className)}
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path d="M17.9091 6.58151v8.36909c0 .3842-.4088.6336-.7557.4616L.314836 7.04311c-.491423-.24427-.31595551-.97768.233956-.97768H17.3873c.2879 0 .5218.23109.5218.51608ZM27.6848 6.94678l-7.865 7.78362c-.3286.3251-.89.0952-.89-.3653V6.58151c0-.28499.2334-.51608.5218-.51608h7.8651c.465 0 .6973.55622.3687.88135h-.0006ZM29.2766 8.01557v7.77733c0 .285-.2333.5161-.5218.5161h-7.8582c-.465 0-.6972-.5562-.3687-.8814l7.8582-7.7773c.3286-.32513.89-.09518.89.36527h.0005ZM20.2951 17.3188h8.4597c.2879 0 .5218.2311.5218.5161v16.674c0 .5442-.7409.7179-.988.2317l-8.4597-16.674c-.1743-.3429.078-.7478.4662-.7478ZM34.0733 4.83494c-.7173 1.22942-2.3114 1.65203-3.5535.94214-1.2426-.7099-1.6692-2.28796-.9518-3.5168.7173-1.22942 2.3108-1.652029 3.5535-.94213 1.242.70989 1.6692 2.28795.9518 3.51679Z"/>
      </svg>
    );
  }
);

SarasIQ.displayName = 'SarasIQ';

export default SarasIQ;
